// extracted by css-extract-rspack-plugin
export default {"userRoleManagement":"NTJ_aPrLJsNyyMLX","labelContent":"HQZUMcLQrbMjmpEp"};